/**
 * MemorySection
 *
 * Placeholder page for the user-facing view of clinical memory. Reachable
 * via the sidebar profile popup's "Memory" row.
 *
 * Full UI is TBD — see the profile-page roadmap. v1 is expected to surface
 * the synthesized memory layer (digests / gestalts / life facts / person
 * profiles) that isn't currently user-visible. Deletion arrives later, once
 * the cascade-recompute path is designed.
 */

export class MemorySection {
  /**
   * @param {Object} elements
   * @param {HTMLElement} elements.container - The #memory-page div
   * @param {EventBus} [eventBus]
   */
  constructor(elements, eventBus) {
    this.container = elements.container;
    this.eventBus = eventBus;
    this.isActive = false;
  }

  async activate() {
    if (this.isActive) return;
    this.isActive = true;
    this.render();
  }

  deactivate() {
    this.isActive = false;
  }

  render() {
    this.container.innerHTML = `
      <div class="explore-section">
        <div class="explore-container">
          <!-- Single-slice surface: the title is the only pinned row, so the
               base [data-sticky-slice] rule is the whole behaviour and no
               StickyStack controller is needed (see components/sticky-stack.css). -->
          <div class="explore-view--list" data-sticky-stack>
            <h2 class="page-header__title content-width" data-sticky-slice>Memory</h2>

            <div class="page-header content-width">
              <div class="page-header__subtitle-row">
                <p class="page-header__subtitle">See what we've learned about you, and manage what we remember.</p>
              </div>
            </div>

            <div class="settings-column">
              <section class="placeholder-page__card">
                <h2 class="placeholder-page__card-title">Coming soon</h2>
                <p class="placeholder-page__card-body">
                  A browsable view of the picture we've built of you over time —
                  themes, patterns, and long-term context. You'll be able to review
                  individual memories and remove anything you don't want us to keep.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}

export default MemorySection;
